import React from "react";

export const ScoreHome = () => {
  return <div>ScoreHome</div>;
};
